import { render, staticRenderFns } from "./EditUserAddress.vue?vue&type=template&id=6319918e&"
import script from "./EditUserAddress.vue?vue&type=script&lang=js&"
export * from "./EditUserAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports